import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {sdgGray, sdgs} from 'src/app/services/utils';

@Component({
    selector: 'app-sdgs-modal',
    templateUrl: './sdgs-modal.component.html',
    styleUrls: ['./sdgs-modal.component.scss'],
    standalone: false
})

export class SDGsModalComponent implements OnInit {

  descSDG = sdgs;
  sdgsGray = sdgGray;

  constructor(
    private modalController: ModalController
  ) {
  }

  ngOnInit() {
  }

  public async closeModal(): Promise<void> {
    await this.modalController.dismiss(null, 'cancel');
  }
}
